import {Component, OnInit} from '@angular/core';
import {fuseAnimations} from '../../../../core/animations';
import {ModulesService} from '../../../../core/services/modules.service';

@Component({
    selector: 'modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class ModulesComponent implements OnInit {
  modules = [];
  displayedColumns = [ 'title', 'status', 'description', 'url', 'edit' ];
  constructor(public modulesService: ModulesService) {
  }

  ngOnInit() {
    this.getModules();
  }

  getModules() {
    this.modulesService.getModules().subscribe((res: any) => {
      this.modules = res;
    });
  }
}
